

import React, { useState, useEffect } from "react";
import { Link, useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import secureLocalStorage from "./storage";
import Footer from "./Footer";
import Manubar from "./Manubar";
import { ToastContainer, toast } from "react-toastify";
import "./StoreDetail.css";

const Modal = ({ onClose, children }) => (
  <div className="modal-overlay" onClick={onClose}>
    <div className="modal-box" onClick={(e) => e.stopPropagation()}>
      <button className="modal-close-btn" onClick={onClose}>
        ×
      </button>
      {children}
    </div>
  </div>
);

const StoreDetail = () => {
  const { storeSlug } = useParams();
  const navigate = useNavigate();

  const [store, setStore] = useState(null);
  const [popularStores, setPopularStores] = useState([]);
  const [loading, setLoading] = useState(true);

  const [activeBanner, setActiveBanner] = useState(0);
  const [descExpanded, setDescExpanded] = useState(false);
  const [activeModal, setActiveModal] = useState(null);
  const [relatedOpen, setRelatedOpen] = useState(true);
  const [popularOpen, setPopularOpen] = useState(true);

  // Rating popup state
  const [selectedStars, setSelectedStars] = useState(0);
  const [hoverStars, setHoverStars] = useState(0);

  const fetchStore = async () => {
    setLoading(true);
    try {
      const { data } = await axios.get(
        `${process.env.REACT_APP_API}website/store/${storeSlug}`
      );
      if (data?.success) {
        setStore(data.store);
        setPopularStores(data.popularStores || []);
      }
    } catch (error) {
      console.log("GetStoreBySlug Error:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    setDescExpanded(false);
    setActiveBanner(0);
    setSelectedStars(0);
    fetchStore();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [storeSlug]);

  useEffect(() => {
    if (!store?.gallery_images?.length) return;
    const id = setInterval(() => {
      setActiveBanner((prev) => (prev + 1) % store.gallery_images.length);
    }, 4000);
    return () => clearInterval(id);
  }, [store]);

const handleEarnCashback = () => {
  const userId = secureLocalStorage.getItem("n_id");
  const token = secureLocalStorage.getItem("n_token");

  if (!userId || !token) {
    navigate("/login");
    return;
  }
 window.open(`/visit/store/${store._id}`, "_blank");
  // navigate(`/visit/store/${store._id}`, "_blank"); 
};

  const submitRating = async () => {
    const token = secureLocalStorage.getItem("n_token");
    if (!token) {
      navigate("/login");
      return;
    }
    try {
      const { data } = await axios.post(
      `${process.env.REACT_APP_API}website/rate_store/${store._id}`,
        { rating: selectedStars },
        { headers: { token } }
      );
      if (data?.success) {
        setStore((prev) => ({
          ...prev,
          avg_rating: data.avg_rating,
          total_ratings: data.total_ratings,
        }));
        toast.success("Rating submitted!");
        setActiveModal(null);
      }
    } catch (error) {
      console.log(error);
      toast.error("Failed to submit rating");
    }
  };

  if (loading || !store) {
    return (
      <div className="store-loading">
        <p>Loading...</p>
      </div>
    );
  }

  const galleryUrls =
    store.gallery_images && store.gallery_images.length > 0
      ? store.gallery_images.map(
          (img) => `${process.env.REACT_APP_API}uploads/${img}`
        )
      : ["/assets/images/banner/default.png"];

  const slideImg = galleryUrls[activeBanner] || galleryUrls[0];

  const shortTermsList = (store.terms || []).slice(0, 3);
  const allTermsList = store.terms || [];

  const topOffer =
    store.coupons && store.coupons.length > 0
      ? {
          title: `Top ${store.name} Offers`,
          desc: store.coupons[0].offer_details,
          detailsBullets: store.coupons.map((c) => c.offer_details),
        }
      : null;

  return (
    <>
      <ToastContainer position="top-center" />

      <div className="modal fade offcanvas-modal" id="exampleModal">
        <div className="modal-dialog offcanvas-dialog">
          <div className="modal-content">
            <Manubar />
          </div>
        </div>
      </div>

      <nav className="breadcrumb-section">
        <div className="container">
          <ol className="breadcrumb bg-transparent m-0 p-0 align-items-center">
            <li className="breadcrumb-item">
              <Link to="/">Home</Link>
            </li>
            <li className="breadcrumb-item">
              <Link to="/top-cashback-stores">Stores</Link>
            </li>
            <li className="breadcrumb-item active" aria-current="page">
              {store.name}
            </li>
          </ol>
        </div>
      </nav>

      <section className="store-detail-page">
        <div className="container">
          {/* ================= 2-COLUMN GRID ================= */}
          <div className="store-page-grid">
            {/* ---------------- LEFT COLUMN ---------------- */}
            <div className="store-left-col">
              {/* Banner */}
              <div className="store-banner">
                <img
                  src={slideImg}
                  alt={store.name}
                  className="banner-full-img"
                  onError={(e) => {
                    e.target.src = "/assets/images/banner/default.png";
                  }}
                />
                {galleryUrls.length > 1 && (
                  <div className="banner-dots">
                    {galleryUrls.map((_, i) => (
                      <span
                        key={i}
                        className={i === activeBanner ? "active" : ""}
                        onClick={() => setActiveBanner(i)}
                      ></span>
                    ))}
                  </div>
                )}
              </div>

              {/* Top Offer */}
              {topOffer && (
                <div className="store-section top-offer-box">
                  <h5 className="store-section-title">{topOffer.title}</h5>
                  <p>{topOffer.desc}</p>
                  <button
                    className="see-details-link"
                    onClick={() => setActiveModal("offer")}
                  >
                    See Offer Details →
                  </button>
                </div>
              )}

              {/* Timelines */}
              <div className="store-section">
                <h5 className="store-section-title">Important Timelines</h5>
                <div className="timelines-card">
                  <div className="timeline-item">
                    <div>
                      <div className="timeline-label">Cashback tracks in</div>
                      <div className="timeline-value">{store.tracking_time}</div>
                      <div className="timeline-unit">{store.tracking_unit}</div>
                    </div>
                    <button
                      className="timeline-arrow-btn"
                      onClick={() => setActiveModal("track")}
                    >
                      →
                    </button>
                  </div>

                  <div className="timeline-item">
                    <div>
                      <div className="timeline-label">Cashback confirms in</div>
                      <div className="timeline-value">{store.confirm_time}</div>
                      <div className="timeline-unit">{store.confirm_unit}</div>
                    </div>
                    <button
                      className="timeline-arrow-btn"
                      onClick={() => setActiveModal("confirm")}
                    >
                      →
                    </button>
                  </div>

                  <div className="timeline-item">
                    <div>
                      <div className="timeline-label">
                        Cashback on {store.name} app orders?
                      </div>
                      <div className="timeline-value">
                        {store.app_orders_allowed}
                      </div>
                    </div>
                    <button
                      className="timeline-arrow-btn"
                      onClick={() => setActiveModal("app")}
                    >
                      →
                    </button>
                  </div>
                </div>
              </div>

              {/* Terms */}
              {allTermsList.length > 0 && (
                <div className="store-section terms-box">
                  <h5 className="store-section-title">
                    Important Terms & Conditions
                  </h5>
                  <ul className="terms-list">
                    {shortTermsList.map((term, i) => (
                      <li key={i}>{term}</li>
                    ))}
                  </ul>
                  <button
                    className="see-details-link"
                    onClick={() => setActiveModal("terms")}
                  >
                    View All Terms & Conditions →
                  </button>
                </div>
              )}
            </div>

            {/* ---------------- RIGHT COLUMN ---------------- */}
            <div className="store-right-col">
              <div className="store-info-card">
                <div className="store-logo-rating-row">
                  <div className="store-logo-box">
                    {store.logo ? (
                      <img
                        src={`${process.env.REACT_APP_API}uploads/${store.logo}`}
                        alt={store.name}
                        style={{ maxWidth: "100%", maxHeight: "40px" }}
                      />
                    ) : (
                      store.name
                    )}
                  </div>
                  <div
                    className="store-rating"
                    style={{ cursor: "pointer" }}
                    onClick={() => setActiveModal("rating")}
                  >
                    ⭐ {store.avg_rating} of 5 | {store.total_ratings} Ratings
                  </div>
                </div>

                <div className="store-meta-title">
                  {store.name} {store.category_tag ? `${store.category_tag} Coupons` : "Coupons"}
                </div>
<p className="store-short-desc">
  {descExpanded || store.description.length <= 80
    ? store.description
    : `${store.description.slice(0, 80)}...`}{" "}
  {store.description.length > 80 && (
    <span className="more-link" onClick={() => setDescExpanded((prev) => !prev)}>
      {descExpanded ? "less" : "more"}
    </span>
  )}
</p>

                <hr />

                <div className="cashback-block">
                  {store.discount_text && (
                    <div className="cashback-upto">
                      <strike>{store.discount_text}</strike>
                    </div>
                  )}
                  <div className="cashback-flat">
                    {store.cashback_text}
                  </div>
                  <div className="cashback-note">{store.cashback_subtext}</div>
                </div>

                <a href="#rates" className="view-rates-link">
                  View Cashback Rates →
                </a>

                <button
                  className="earn-cashback-btn"
                  onClick={handleEarnCashback}
                >
                  Earn Cashback on {store.name} →
                </button>
              </div>
            </div>
          </div>
          {/* ================= 2-COLUMN GRID ENDS ================= */}

          <div className="plain-breadcrumb">
            <Link to="/">Home</Link> / <Link to="/top-cashback-stores">Stores</Link> /{" "}
            <strong>{store.name}</strong>
          </div>

          {/* Long Content — CKEditor se aaya poora content */}
          {store.long_content && (
            <div
              className="plain-section"
              dangerouslySetInnerHTML={{ __html: store.long_content }}
            />
          )}

          {/* Coupons Table */}
          {store.coupons && store.coupons.length > 0 && (
            <div className="plain-section">
              <h5 className="store-section-title">
                Latest {store.name} Offers and Discount Codes
              </h5>
              <table className="table table-bordered">
                <thead>
                  <tr>
                    <th>Coupon</th>
                    <th>Offer Details</th>
                    <th>Validity</th>
                  </tr>
                </thead>
                <tbody>
                  {store.coupons.map((c, i) => (
                    <tr key={i}>
                      <td>{c.code_title}</td>
                      <td>{c.offer_details}</td>
                      <td>{c.validity}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}

          {/* Related Stores */}
          {store.related_stores?.length > 0 && (
            <div className="plain-section">
              <div
                className="collapsible-header"
                onClick={() => setRelatedOpen((p) => !p)}
              >
                <h5 className="store-section-title">Related Stores</h5>
                <span>{relatedOpen ? "▲" : "▼"}</span>
              </div>
              {relatedOpen && (
                <div className="stores-grid">
                  {store.related_stores.map((rs) => (
                    <span
                      className="store-link"
                      key={rs._id}
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate(`/stores/${rs.slug}`)}
                    >
                      {rs.name}
                    </span>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* Popular Stores */}
          {popularStores?.length > 0 && (
            <div className="plain-section">
              <div
                className="collapsible-header"
                onClick={() => setPopularOpen((p) => !p)}
              >
                <h5 className="store-section-title">Popular Stores</h5>
                <span>{popularOpen ? "▲" : "▼"}</span>
              </div>
              {popularOpen && (
                <div className="stores-grid">
                  {popularStores.map((ps) => (
                    <span
                      className="store-link"
                      key={ps._id}
                      style={{ cursor: "pointer" }}
                      onClick={() => navigate(`/stores/${ps.slug}`)}
                    >
                      {ps.name}
                    </span>
                  ))}
                </div>
              )}
            </div>
          )}

          {/* FAQs */}
          {store.faqs?.length > 0 && (
            <div className="plain-section">
              <h5 className="store-section-title">
                Frequently Asked Questions about {store.name}
              </h5>
              <div className="faq-grid">
                {store.faqs.map((f, i) => (
                  <div className="faq-item" key={i}>
                    <p className="faq-q">Q. {f.question}</p>
                    <p className="faq-a">A. {f.answer}</p>
                  </div>
                ))}
              </div>
            </div>
          )}

          {/* How CashKaroNa Works - static, generic */}
          <div className="plain-section">
            <h5 className="store-section-title">How CashKaroNa Works</h5>
            <div className="how-it-works-grid">
              {[
                "Sign up or log in to your CashKaroNa account.",
                `Search for the ${store.name} store page and click 'Earn Cashback on ${store.name}'.`,
                `Shop as usual on ${store.name} without exiting the session.`,
                "Cashback gets tracked in your account and confirmed after the tracking period.",
              ].map((step, i) => (
                <div className="how-step" key={i}>
                  <div className="how-step-num">{i + 1}</div>
                  <p>{step}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Footer />

      {activeModal === "offer" && topOffer && (
        <Modal onClose={() => setActiveModal(null)}>
          <h4 className="modal-title">More Details About the Offer</h4>
          <ul className="terms-list">
            {topOffer.detailsBullets.map((b, i) => (
              <li key={i}>{b}</li>
            ))}
          </ul>
        </Modal>
      )}

    {activeModal === "track" && (
  <Modal onClose={() => setActiveModal(null)}>
    <h4 className="modal-title">Cashback Tracking Timeline</h4>
    <div className="modal-icon">
      <img src="/assets/images/icon/timeline.png" alt="Track" width="70" />
    </div>
    <p className="modal-center-text">
      Your Cashback will be added in {store.tracking_time} {store.tracking_unit}
    </p>
    <button className="modal-ok-btn" onClick={() => setActiveModal(null)}>
      Okay, got it
    </button>
  </Modal>
)}

    {activeModal === "confirm" && (
  <Modal onClose={() => setActiveModal(null)}>
    <h4 className="modal-title">Cashback Confirmation Timeline</h4>
    <div className="modal-icon">
      <img src="/assets/images/icon/clock.png" alt="Confirm" width="70" />
    </div>
    <p className="modal-center-text">
      Your Cashback will be confirmed within {store.confirm_time} {store.confirm_unit}
    </p>
    <button className="modal-ok-btn" onClick={() => setActiveModal(null)}>
      Okay, got it
    </button>
  </Modal>
)}

     {activeModal === "app" && (
  <Modal onClose={() => setActiveModal(null)}>
    <h4 className="modal-title">App Orders Cashback</h4>
    <div className="modal-icon">
      <img src="/assets/images/icon/app.png" alt="App Orders" width="70" />
    </div>
    <p className="modal-center-text">
      {store.app_orders_allowed === "YES"
        ? `Yes, Cashback is credited on ${store.name} app orders too.`
        : `No, Cashback is not credited on ${store.name} app orders.`}
    </p>
    <button className="modal-ok-btn" onClick={() => setActiveModal(null)}>
      Okay, got it
    </button>
  </Modal>
)}

      {activeModal === "terms" && (
        <Modal onClose={() => setActiveModal(null)}>
          <h4 className="modal-title">Terms & Conditions</h4>
          <ul className="terms-list">
            {allTermsList.map((t, i) => (
              <li key={i}>{t}</li>
            ))}
          </ul>
        </Modal>
      )}

      {activeModal === "rating" && (
        <Modal onClose={() => setActiveModal(null)}>
          <h4 className="modal-title">Rate the Store</h4>
          <div style={{ textAlign: "center", margin: "15px 0" }}>
            {[1, 2, 3, 4, 5].map((star) => (
              <span
                key={star}
                onClick={() => setSelectedStars(star)}
                onMouseEnter={() => setHoverStars(star)}
                onMouseLeave={() => setHoverStars(0)}
                style={{
                  fontSize: "32px",
                  cursor: "pointer",
                  color:
                    (hoverStars || selectedStars) >= star ? "#f5a623" : "#ddd",
                }}
              >
                ★
              </span>
            ))}
          </div>
          <p className="modal-center-text">
            Rated {store.avg_rating} of 5 | Out of {store.total_ratings} votes
          </p>
          <button
            className="modal-ok-btn"
            onClick={submitRating}
            disabled={selectedStars === 0}
          >
            Submit Rating
          </button>
        </Modal>
      )}
    </>
  );
};

export default StoreDetail;